var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGovernment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.888,
    height: 27.454,
    viewBox: "0 0 28.888 27.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.75 -3.498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.523,13.333H2.66a.41.41,0,0,1-.41-.41V9.645A.41.41,0,0,1,2.5,9.268L16.436,3.532a.377.377,0,0,1,.311,0L30.679,9.268a.41.41,0,0,1,.254.377v3.278A.41.41,0,0,1,30.523,13.333ZM3.07,12.513H30.113V9.92L16.591,4.351,3.07,9.92Z",
    transform: "translate(-0.295 0)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.228,64.6H2.16a.41.41,0,0,1-.41-.41V62.139A1.639,1.639,0,0,1,3.389,60.5H29a1.639,1.639,0,0,1,1.639,1.639v2.049A.41.41,0,0,1,30.228,64.6ZM2.57,63.778H29.818V62.139a.82.82,0,0,0-.82-.82H3.389a.82.82,0,0,0-.82.82Z",
    transform: "translate(0 -33.645)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.441,57.188H49.16a.41.41,0,0,1-.41-.41V54.32a.82.82,0,0,1,.82-.82h5.462a.82.82,0,0,1,.82.82v2.459A.41.41,0,0,1,55.441,57.188Zm-5.872-.82h5.462V54.32H49.57Z",
    transform: "translate(-27.742 -29.514)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.032,29.188H49.57a.82.82,0,0,1-.82-.82V25.91a.41.41,0,0,1,.41-.41h6.282a.41.41,0,0,1,.41.41v2.459A.82.82,0,0,1,55.032,29.188ZM49.57,26.32v2.049h5.462V26.32Z",
    transform: "translate(-27.742 -12.987)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.983,41.924H52.16a.41.41,0,0,1-.41-.41v-8.6a.41.41,0,0,1,.41-.41h3.823a.41.41,0,0,1,.41.41v8.6A.41.41,0,0,1,55.983,41.924ZM52.57,41.1h3V33.32h-3Z",
    transform: "translate(-29.512 -17.118)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.111,57.188H8.83a.41.41,0,0,1-.41-.41V54.32a.82.82,0,0,1,.82-.82H14.7a.82.82,0,0,1,.82.82v2.459A.41.41,0,0,1,15.111,57.188Zm-5.872-.82H14.7V54.32H9.24Z",
    transform: "translate(-3.937 -29.514)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7,29.188H9.24a.82.82,0,0,1-.82-.82V25.91a.41.41,0,0,1,.41-.41h6.282a.41.41,0,0,1,.41.41v2.459A.82.82,0,0,1,14.7,29.188ZM9.24,26.32v2.049H14.7V26.32Z",
    transform: "translate(-3.937 -12.987)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.653,41.924H11.83a.41.41,0,0,1-.41-.41v-8.6a.41.41,0,0,1,.41-.41h3.823a.41.41,0,0,1,.41.41v8.6A.41.41,0,0,1,15.653,41.924ZM12.24,41.1h3V33.32h-3Z",
    transform: "translate(-5.708 -17.118)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.765,15.011a2.245,2.245,0,1,1,2.245-2.245A2.245,2.245,0,0,1,33.765,15.011Zm0-3.688a1.434,1.434,0,1,1,0,.016Z",
    transform: "translate(-17.572 -4.145)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/government.e49d18da.svg";
export { ForwardRef as ReactComponent };